var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayCommissionsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.666 13.4141C11.666 13.4141 12.4993 13.4141 13.3327 15.0807C13.3327 15.0807 15.9802 10.9141 18.3327 10.0807M4.58268 7.58073H4.57518M9.16601 14.2474H8.74935C5.61685 14.2474 4.05102 14.2474 3.00518 13.4224C2.83898 13.2907 2.68451 13.1449 2.54352 12.9866C1.66602 12.0032 1.66602 10.5282 1.66602 7.58073C1.66602 4.63323 1.66602 3.15906 2.54352 2.1749C2.68407 2.01712 2.83796 1.87212 3.00518 1.7399C4.05102 0.914063 5.61685 0.914063 8.74935 0.914063H11.2493C14.3818 0.914063 15.9477 0.914062 16.9927 1.73906C17.1605 1.8724 17.3146 2.01767 17.4552 2.1749C18.246 3.06156 18.3243 4.34573 18.3327 6.7474V7.16406",
    stroke: "#243142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0827 7.58333C12.0827 8.13587 11.8632 8.66577 11.4725 9.05647C11.0818 9.44717 10.5519 9.66667 9.99935 9.66667C9.44681 9.66667 8.91691 9.44717 8.52621 9.05647C8.13551 8.66577 7.91602 8.13587 7.91602 7.58333C7.91602 7.0308 8.13551 6.50089 8.52621 6.11019C8.91691 5.71949 9.44681 5.5 9.99935 5.5C10.5519 5.5 11.0818 5.71949 11.4725 6.11019C11.8632 6.50089 12.0827 7.0308 12.0827 7.58333Z",
    stroke: "#243142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCommissionsIcon);
export default __webpack_public_path__ + "static/media/payCommissionsIcon.93ba2a72ff995ee2277ebacc447385e7.svg";
export { ForwardRef as ReactComponent };